module.exports = __webpack_public_path__ + "img/vehicle-maintenance-log-book_B09KNGG2DZ.899b6cd0.jpg";